const glp1UtilizationMessages = {
  GLP1_PAGE: {
    TITLE: 'GLP-1 Drug Utilization',
    SUB_TITLE:
      'Analyzes usage, spending, and member demographics for GLP drugs, identifying whether they are used by members with or without a diabetes diagnosis.',
    CARDS: {
      MEMBERS: 'Cohort Members',
      TOTAL_COST: 'Cohort Cost',
      PMPM: 'Cohort PMPM',
    },
    DURGS_TABLE: {
      TITLE: 'GLP-1 Drugs',
      SUB_TITLE: 'List of GLP-1 Drugs filled in the selected period',
    },
    PIE_CHART: {
      TITLE: 'Comparison of Diabetic and Non-Diabetic',
      SUB_TITLE: 'Use toggle on right to switch between cost and members',
    },
    MEMBERS_TABLE: {
      TITLE: 'Member Details',
      SUB_TITLE: 'Click on the drop down to see claims of GLP-1 Drugs',
    },
  },
};

export default glp1UtilizationMessages;
